import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withStyles, Paper, Grid, Button, CircularProgress, Typography } from '@material-ui/core'
import { Field, reduxForm } from 'redux-form'

import { Input } from 'components'
import { authActions } from 'reduxModules/actions/AuthActions'
import { isLoadingSelector } from 'reduxModules/selectors/AuthSelectors'
import { email, required, minLength8 } from 'services/validations'
import imgs from 'assets/imgs'

import packageJson from '../../../package.json';

const styles = theme => ({
  container: {
    width: '100%',
  },
  paper: {
    marginTop: theme.spacing.unit * 14,
    padding: theme.spacing.unit * 4,
    maxWidth: 350,
    margin: 'auto'
  },
  logo: {
    width: 250,
    display: 'block',
    margin: 'auto'
  },
  button: {
    marginTop: theme.spacing.unit * 4,
    width: '100%'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

class SignInPage extends Component {
  render() {
    const { classes, handleSubmit, emailSignIn, isLoading, invalid } = this.props

    return (
      <Grid
        container
        spacing={2}
        justify='center'
        component='section'
        alignItems='center'
        className={classes.container}
      >
        <Grid
          item
          xs={12}
          component={Paper}
          className={classes.paper}
        >
          <img src={imgs.logo} alt='Compass' className={classes.logo} />

          <form onSubmit={handleSubmit(emailSignIn)}>
            <Field
              fullWidth
              name='login'
              label='Логін'
              margin='normal'
              validate={[required, email]}
              component={Input}
              helperText='Будь ласка введіть ваш емейл'
            />

            <Field
              fullWidth
              name='password'
              type='password'
              label='Пароль'
              margin='normal'
              validate={[required, minLength8]}
              component={Input}
              helperText='Будь ласка введіть ваш пароль'
            />

            <Button
              type='submit'
              variant='outlined'
              disabled={invalid || isLoading}
              className={classes.button}
            >
              Увійти
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Button>
          </form>
        </Grid>
        <Grid item xs={12}>
          <Typography align='center' variant='caption'>
            v{packageJson.version}
          </Typography>
        </Grid>
      </Grid>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isLoading: isLoadingSelector
})

const mapDispatchToProps = {
  emailSignIn: authActions.emailSignIn,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'login'
  }),
  withStyles(styles)
)

export default enhance(SignInPage)


// WEBPACK FOOTER //
// ./src/routes/SignInPage/SignInPage.js